import React from 'react';
import { BoxV2 as Box } from 'portal-commons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DetailsSection = ({
  title,
  icon,
  children,
  'data-testid': testId,
}: {
  title: string;
  icon?: IconDefinition;
  children: React.ReactNode;
  'data-testid'?: string;
}) => (
  <Box as="section" sx={{ width: '100%' }} data-testid={testId}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        fontSize: '18px',
        color: '#4d5659',
        gap: '8px',
        mb: '16px',
      }}
    >
      {icon && <FontAwesomeIcon icon={icon} fontSize="24px" />}
      <Box as="h2" sx={{ fontSize: '18px', fontWeight: '600' }}>
        {title}
      </Box>
    </Box>
    <Box
      sx={{
        width: '100%',
        fontWeight: 'semiBold',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
      }}
    >
      {children}
    </Box>
  </Box>
);

export default DetailsSection;
